import { Component, computed, inject } from '@angular/core'
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router'

import { AppConfigService } from 'app/app-config.service'
import { UserStore } from 'app/store/user.store'

@Component({
  selector: 'app-account',
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent {
  userStore = inject(UserStore)
  appConfigService = inject(AppConfigService)

  storefrontId = this.appConfigService.getAppConfig?.id

  canViewOrders = computed(() =>
    this.userStore
      .user()
      ?.permissions.some(
        permission => permission.name === 'storefronts.orders.' + this.storefrontId
      )
  )

  canViewStoreCredits = computed(() =>
    this.userStore
      .user()
      ?.permissions.some(
        permission => permission.name === 'storefronts.gift-cards.' + this.storefrontId
      )
  )
}
